import * as types from 'models/actionTypes'

export const requestFavorites = () => ({
    type: types.REQUEST_FAVORITES,
})

export const receiveFavorites = (favorites) => ({
    type: types.RECEIVE_FAVORITES,
    favorites,
})

export const failedReceiveFavorites = () => ({
    type: types.FAILED_RECEIVE_FAVORITES,
})

export const toggleFavorite = (localItemNumber, isFavorite, trackingInfo) => ({
    type: types.TOGGLE_FAVORITE,
    localItemNumber,
    isFavorite,
    trackingInfo,
})

export const toggleFavorites = (itemsToFavorite, isFavorite, trackingInfo = {}) => ({
    type: types.TOGGLE_FAVORITES,
    itemsToFavorite,
    isFavorite,
    trackingInfo,
})
